/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import ChartLoader from '../../Loaders/ChartLoader';
import useGenerateChartData from '../../../hooks/useGenerateChartData';
import OGHighchart from '../../Charts/OGHighchart';
import { getVoltageForecastData } from '../../../Service/APIService';
import { chartBlue, chartRed, chartYellow } from '../../../shared/config';

const VoltageDetailsChartNew = ({ deviceId, status, selectedObj }) => {
  const { loading, options, error, fetchChartData } = useGenerateChartData({
    apiService: getVoltageForecastData,
    responseParameter: {
      data: 'voltagevsTimeForecastData',
      unit: 'VoltageUnit',
    },
    config: {
      series: {
        r_RMSVoltage: 'R_voltage',
        y_RMSVoltage: 'Y_voltage',
        b_RMSVoltage: 'B_voltage',
      },
      colors: {
        r_RMSVoltage: chartRed,
        y_RMSVoltage: chartYellow,
        b_RMSVoltage: chartBlue,
      },
      labels: {
        r_RMSVoltage: 'voltage_R',
        y_RMSVoltage: 'voltage_Y',
        b_RMSVoltage: 'voltage_B',
      },
      units: 'unit',
    },
    selectedObj,
  });

  useEffect(() => {
    fetchChartData(deviceId, `${status}-0`);
  }, [deviceId, status]);

  const chartData = useMemo(() => {
    if (options) {
      return {
        series: options.series,
        config: options.config,
      };
    }
  }, [options]);

  if (loading) {
    return <ChartLoader height="150" width="600" />;
  }

  if (error) {
    return <div>Error loading data.</div>;
  }

  return (
    <OGHighchart
      config={chartData.config}
      series={chartData.series}
      onAllClick={() => fetchChartData(deviceId, `${status}-6`)}
    />
  ); //<Voltage options={options} onAllClick={() => getVoltageData(deviceId, `${status}-6`)} />;
};

export default VoltageDetailsChartNew;
